import React, { ReactNode } from "react";
import styles from "./filterBar.module.css";

interface FilterBarProps {
    children: ReactNode;
}

export const FilterBar: React.FC<FilterBarProps> = ({ children }) => {
    return <div className={styles.bar}>{children}</div>;
};
